import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from '../actions/messageDetail';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IDeleteMessagesParam,
} from '../scenario/MessageDetailScenarioFactory';

const styles = (theme: Theme) =>
	createStyles({
		message: {
			marginTop: theme.spacing(3),
			overflowWrap: 'break-word',
			padding: theme.spacing(2),
			wordWrap: 'break-word',
		},
		messageBody: {
			background: `radial-gradient(transparent, ${theme.palette.primary
				.main + '10'})`,
			borderRadius: theme.spacing(2),
			marginTop: theme.spacing(3),
			padding: theme.spacing(2),
		},
		root: {
			padding: theme.spacing(2),
		},
		wordBreak: {
			display: 'block',
			wordBreak: 'break-word',
		},
	});

interface IState {
	deleting?: [string, string]; // messageID, organizationID
}

/**
 * メッセージ一覧
 */
class MessageDetail extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.props.fetchOnesName(this.props.token);
		this.props.fetchMessages(this.props.token);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearMessages();
	}

	public render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				<Typography variant="h5">
					{i18n.t('MessageDetail_0001', {
						onesName: this.props.onesName,
					})}
				</Typography>
				{this.props.messages.map(m => (
					<Paper key={m.messageID} className={classes.message}>
						<Typography
							variant="caption"
							className={this.props.classes.wordBreak}
						>
							{m.startDateStr}
						</Typography>
						<span
							dangerouslySetInnerHTML={{ __html: ' ' + m.title }}
						/>
						<div className={classes.messageBody}>
							{m.messageList.map((msg, i) => (
								<React.Fragment key={i}>
									<span
										dangerouslySetInnerHTML={{
											__html: msg,
										}}
									/>
									<br />
								</React.Fragment>
							))}
						</div>
						{m.contact && (
							<Typography variant="body1" align="right">
								{m.contact}
							</Typography>
						)}
						<Grid container={true} justify="flex-end">
							<Grid item={true}>
								<IconButton
									aria-label="Delete"
									onClick={this.handleDeleteButton(
										m.messageID,
										m.organizationID
									)}
								>
									<DeleteIcon />
								</IconButton>
							</Grid>
						</Grid>
					</Paper>
				))}
				<Dialog
					open={this.state.deleting !== undefined}
					onClose={this.handleDeleteConfirm}
				>
					<DialogTitle id="delete-confirm">
						{i18n.t('MessageDetail_0002')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="delete-confirm">
							{i18n.t('MessageDetail_0003')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleDelete} color="primary">
							{i18n.t('MessageDetail_0004')}
						</Button>
						<Button onClick={this.handleDeleteConfirm}>
							{i18n.t('MessageDetail_0005')}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}

	/**
	 * 削除ボタン押下時ハンドラ
	 */
	protected handleDeleteButton = (
		messageID: string,
		organizationID: string
	) => () => {
		this.setState({
			deleting: [messageID, organizationID],
		});
	};

	/**
	 * 削除実施ハンドラ
	 */
	protected handleDelete = () => {
		const deleting = this.state.deleting as [string, string];
		this.props.deleteMessages(this.props.token, {
			messageID: deleting[0],
			organizationID: deleting[1],
		});
		this.setState({ deleting: undefined });
	};

	/**
	 * 削除確認クローズハンドラ
	 */
	protected handleDeleteConfirm = () => {
		this.setState({ deleting: undefined });
	};
}

const mapStateToProps = (state: IRootState) => ({
	messages: state.messageDetail.messages,
	onesName: state.messageDetail.onesName,

	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearMessages: () => dispatch(Actions.clearMessageList({})),
	deleteMessages: (token: string, arg: IDeleteMessagesParam) => {
		const s = ScenarioFactory.createDeleteMessages(dispatch, token);
		s.run(arg);
	},
	fetchMessages: (token: string) => {
		const s = ScenarioFactory.createFetchMessages(dispatch, token);
		s.run({});
	},
	fetchOnesName: (token: string) => {
		const s = ScenarioFactory.createFetchOnesName(dispatch, token);
		s.run({});
	},
});

// tslint:disable-next-line: no-empty-interface
export interface IMessageDetailProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IMessageDetailProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(MessageDetail);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/MessageDetail.tsx